import { render } from "./PrcHandle.vue?vue&type=template&id=5906276e&scoped=true"
import script from "./PrcHandle.vue?vue&type=script&lang=js"
export * from "./PrcHandle.vue?vue&type=script&lang=js"

import "./PrcHandle.vue?vue&type=style&index=0&id=5906276e&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906276e"]])

export default __exports__